export default __webpack_public_path__ + "static/media/export-comments-bg.a85c1acf.png";